import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getToken, onMessage } from 'firebase/messaging';
import { getMessaging } from 'firebase/messaging/sw';

// import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCUSghpoCil3f0Cv3vIDX5SFPr5gAS1h98',
  authDomain: 'gestion-fc.firebaseapp.com',
  databaseURL: 'https://gestion-fc.firebaseio.com',
  projectId: 'gestion-fc',
  storageBucket: 'gestion-fc.appspot.com',
  messagingSenderId: '758335066505',
  appId: '1:758335066505:web:06512659345702ec73d158',
  measurementId: 'G-H4FJKK7ZD6',
};

const provider = new GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/contacts.readonly');

// Initialize Firebase and Firestore
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
auth.useDeviceLanguage();
// const analytics = getAnalytics(app);

const messaging = getMessaging(app);
// Add the public key generated from the console here.
const fcmToken = getToken(messaging, {
  vapidKey:
    'BPSnNRW46KbkacViXMfP28VkDnokYz8QQvTZXgoeiorxwj_OXhR8wLD7yeHRJQjVdNqBQxrNJNMZAJv2yvnIKe0',
});

if (navigator.serviceWorker) {
  // Register the SW
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then(registration => {})
    .catch(console.log);
}

const onMessageListener = () =>
  new Promise(resolve => {
    onMessage(messaging, payload => {
      // create a notification object
      const greeting = new Notification(payload.notification.title, {
        body: payload.notification.body,
        icon: './img/goodday.png',
        url: payload.data['gcm.notification.url'],
      });
      greeting.addEventListener('click', () => {
        window.open(payload.data['gcm.notification.url'], '_blank');
      });
      resolve(payload);
    });
  });

export { db, auth, messaging, fcmToken, onMessageListener };
